import { Button } from '@mui/material'
import type { ReactNode } from 'react'
import { colors, fontWeights, borderRadius } from '@/theme'

interface TabButtonProps {
  active: boolean
  onClick: () => void
  children: ReactNode
  disabled?: boolean
}

export default function TabButton({ active, onClick, children, disabled }: TabButtonProps) {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      variant={active ? 'primary' : 'secondary'}
      sx={{
        width: '235px',
        height: '56px',
        fontWeight: fontWeights.semibold,
        lineHeight: '170%',
        borderRadius: borderRadius.lg,
        ...(active
          ? {}
          : {
              bgcolor: colors.background.paper,
              color: colors.text.black
            })
      }}
    >
      {children}
    </Button>
  )
}
